export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=00e24c2e&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/notifications/index.vue?vue&type=template&id=00e24c2e&
// module id = 1410
// module chunks = 0